// eslint-disable-next-line
import React from "react";
import { ColorRing } from "react-loader-spinner";

function Loading() {
  return (
    <div className="flex justify-center items-center h-screen">
      <ColorRing
        visible={true}
        height="80"
        width="30"
        ariaLabel="color-ring-loading"
        wrapperStyle={{}}
        wrapperClass="color-ring-wrapper"
        colors={["#32e5ff", "#32e5ff", "#32e5ff", "#32e5ff", "#32e5ff"]}
      />
    </div>
  );
}

export default Loading;
